import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b2f9e43e"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["disabled", "onClick"];
const _hoisted_2 = {
    key: 0,
    class: "cl-icon"
};
const _hoisted_3 = {
    key: 1,
    class: "cl-icon"
};
import { useSlots } from "vue";
//判断<slot/>是否有传值
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    props: {
        type: { default: "" },
        size: { default: "" },
        icon: { default: "" },
        border: { type: Boolean, default: true },
        text: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
        noPadding: { type: Boolean, default: false },
        onClick: null
    },
    emits: ["click"],
    setup(__props, { emit: emits }) {
        const slotDefault = !!useSlots().default;
        const clickHandle = (e) => {
            emits("click", e);
        };
        return (_ctx, _cache) => {
            const _component_svg_icon = _resolveComponent("svg-icon");
            return (_openBlock(), _createElementBlock("button", {
                disabled: __props.disabled || __props.loading,
                class: _normalizeClass(["cl-button", [
                        __props.type ? 'cl-button--' + __props.type : '',
                        __props.size ? 'cl-button--' + __props.size : '',
                        __props.text ? 'cl-button--text' : '',
                        {
                            'is-disabled': __props.disabled || __props.loading,
                            'no-text': !slotDefault,
                            'no-icon': __props.icon === '',
                            'no-padding': __props.noPadding
                        }
                    ]]),
                type: "button",
                onClick: _withModifiers(clickHandle, ["prevent"])
            }, [
                (__props.icon !== '' && !__props.loading)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_2, [
                        _createVNode(_component_svg_icon, { "icon-class": __props.icon }, null, 8, ["icon-class"])
                    ]))
                    : _createCommentVNode("", true),
                (__props.loading)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_3, [
                        _createVNode(_component_svg_icon, {
                            "icon-class": "loading",
                            "class-name": "loading-animation"
                        })
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("span", null, [
                    _renderSlot(_ctx.$slots, "default")
                ])
            ], 10, _hoisted_1));
        };
    }
});
